import { Spinner, VStack } from '@chakra-ui/react';
import { Permission } from '@common/permissions';
import React, { useEffect } from 'react';
import { usePermissions, useSession } from 'src/apps/invest/common/hooks';
import { useDocumentsViewModel } from '../models/DocumentsViewModel';
import { DocumentsPage } from '../views/DocumentsPage';

const sessionRedirect = window.location.pathname;
const permissions: Permission[] = ['ACCREDITED_INVESTOR', 'UNACCREDITED_INVESTOR'];

type DocumentsPage = 'DOCUMENTS' | 'STATEMENT';

export const DocumentsController: React.FC = () => {
  const { checkAuthenticated } = useSession();
  const { checkPermissions } = usePermissions();

  const documentsViewModel = useDocumentsViewModel();

  async function init() {
    if (!(await checkAuthenticated(sessionRedirect))) return;
    if (!(await checkPermissions(permissions))) return;

    documentsViewModel.init();
    documentsViewModel.setIsLoading(false);
  }

  useEffect(() => {
    init();
  }, []);

  return documentsViewModel.isLoading ? (
    <VStack height="100%" justifyContent={'center'} backgroundColor="transparent">
      <Spinner size="lg" color="blue.500" />
    </VStack>
  ) : (
    <DocumentsPage />
  );
};
